import { useEffect, useRef } from 'react';

const usePrevious = (value: any): any => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current = value;
  });

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};

export default usePrevious;
